export default __webpack_public_path__ + "static/media/wsoc-01.ff8317ca.svg";